<template>
  <div>
    <v-card class="pa-4" v-if="!editable">
      <v-row wrap>
        <v-col cols="3" xs="12" md3 mb-3>
          <div class="text-capitalize overline text--secondary">Shop</div>
          {{ model.shop.name }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">Customer</div>
          {{ model.client.displayName }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">Location</div>
          {{ model.location.name }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">Shipping</div>
          {{ model.pickup ? 'Pickup' : model.shipping.name }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">Currency</div>
          {{ model.currency.currency }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">Tax Rate</div>
          {{ model.taxRate.name }}
        </v-col>
        <v-col cols="3" xs="12" mb-3>
          <div class="text-capitalize overline text--secondary">
            Club Fitter
          </div>
          {{ model.clubFitter.displayName }}
        </v-col>
        <v-col>
          <div class="text-capitalize overline text--secondary">
            Client's PO
          </div>
          {{ model.clientPo }}
        </v-col>
      </v-row>
    </v-card>
    <order-form :order="this.model" v-else @orderUpdate="$emit('updated')"></order-form>
  </div>
</template>
<script>
import OrderForm from "./OrderForm";
export default {
  components: {
    OrderForm
  },
  props: {
    order: {
      type: Object
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.order
    };
  },
  computed: {
    isDisabled: function() {
      if (this.order.statusId != "new") return true;
      return false;
    }
  },
};
</script>
